<template>
  <b-card class="card-content">
    <slot name="top"></slot>
    <b-container v-if="container">
      <slot name="contentt"></slot>
    </b-container>
    <div v-else>
      <slot name="contentt"></slot>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "contentt",
  
  props: {
    container: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>

</style>